export const APP_VERSION = 'v1.0.12'; // Phiên bản app, tăng version khi deploy
export const CACHE_VERSION = 'staff-portal-cache-v1.0.12'; // Version cache, phải khớp với CACHE_NAME trong serviceWorker.js 